import { useEffect } from 'react'

export const BANNER_V2_IMAGE_LEAVE_MESSAGE = '선택한 배너 이미지는 저장 전에 이동하면 사라집니다. 이동하시겠습니까?'

export const hasPendingBannerV2Image = (image) => {
    return image instanceof File
}

// 다이얼로그 내부 file input 값은 복구할 수 없어서, 새로고침/탭 닫기 직전에만 기본 경고를 띄운다.
export const usePendingBannerV2ImageUnloadGuard = (enabled) => {
    useEffect(() => {
        if (typeof window === 'undefined' || !enabled) {
            return undefined
        }

        const handleBeforeUnload = (event) => {
            event.preventDefault()
            event.returnValue = ''
            return ''
        }

        window.addEventListener('beforeunload', handleBeforeUnload)

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload)
        }
    }, [enabled])
}
